/* eslint-disable */
/* prettier-ignore-start */
// [GENERATED FILE; DO NOT EDIT BY HAND]

import React from "react"

var element = React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, React.createElement("path", {
  d: "M10 8.507L1.8.307A1.054 1.054 0 10.31 1.8L8.509 10l-8.2 8.2A1.054 1.054 0 001.8 19.69l8.2-8.2 8.2 8.2a1.054 1.054 0 001.491-1.49l-8.2-8.2 8.2-8.2A1.054 1.054 0 0018.2.308l-8.2 8.2z",
  fillRule: "evenodd"
}));

var Svg = React.forwardRef(function (props, ref) {
  var next = { ref: ref };
  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      next[key] = props[key];
    }
  }
  return React.cloneElement(element, next);
});
Svg.displayName = "CloseSheet";
Svg.element = element;
export default Svg;
